import { render, staticRenderFns } from "./CarfaxCard.vue?vue&type=template&id=1a3ac4b9&scoped=true&"
import script from "./CarfaxCard.vue?vue&type=script&lang=js&"
export * from "./CarfaxCard.vue?vue&type=script&lang=js&"
import style0 from "./CarfaxCard.vue?vue&type=style&index=0&id=1a3ac4b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3ac4b9",
  null
  
)

export default component.exports